/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RiskMcpServerCount,
  RiskMcpServerCount$inboundSchema,
} from "./riskmcpservercount.js";

export type RiskMcpServerCountsResult = {
  /**
   * Per-server finding counts, largest first. Servers with no findings are omitted.
   */
  servers: Array<RiskMcpServerCount>;
};

/** @internal */
export const RiskMcpServerCountsResult$inboundSchema: z.ZodMiniType<
  RiskMcpServerCountsResult,
  unknown
> = z.object({
  servers: z.array(RiskMcpServerCount$inboundSchema),
});

export function riskMcpServerCountsResultFromJSON(
  jsonString: string,
): SafeParseResult<RiskMcpServerCountsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskMcpServerCountsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskMcpServerCountsResult' from JSON`,
  );
}
